/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LiquidityProvider } from './liquidityProvider';

/**
 * Aggregated Curve Data DTO
 */
export interface AggregatedCurveDataDto {
  offset: number;
  liquidityProvider: LiquidityProvider;
  buyCurveCount: number;
  sellCurveCount: number;
  /**
   * Quantity for which we have Curve data
   */
  totalCurveQuantity: number;
  /**
   * Trade volume for which we have Curve data
   */
  totalExecutedVolume: number;
  averageInceptionVolume: number;
}
